// import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import IconRefresh from '../svg/IconRefresh';

import { refreshStorePlaylists } from "../../../actions/index";

function ConnectedButtonRefresh({ show, onClick, className }) {
  return (
    <IconRefresh size={20} color={/*Config.BLACK_5*/ '#717171'} onClick={onClick}
      className={`refresh-playlists ${className} ${!show && `none`}`}
    />
  );
}

ConnectedButtonRefresh.propTypes = {
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
}

const ButtonRefresh = connect(
  state => ({
    show: (state.isConnected && !state.enablePM)
  }),
  dispatch => ({
    onClick: () => dispatch(refreshStorePlaylists())
  })
)(ConnectedButtonRefresh);

export default ButtonRefresh;
